import { useContext } from "react";

import { TabsOverrideContext } from "../../context/sectionTabs/TabsOverrideContext";
import type { TabsOverrideContextValue } from "../../context/sectionTabs/types";

const noop = () => {};

/**
 * No-op fallback when consumed outside a MobileSectionTabsProvider.
 * Overrides are silently discarded - the component renders normally
 * but tab registrations don't reach a shell (since there isn't one).
 * This allows mobile content pages to work on both the legacy and new
 * app shell paths without crashing.
 * TODO: Remove this fallback once all pages are migrated
 * to the new app shell and MobileSectionTabsProvider is guaranteed present.
 */
const FALLBACK_CONTEXT: TabsOverrideContextValue = {
  tabsOverride: null,
  setTabsOverride: noop,
  updateSelectedValue: noop,
};

/**
 * Register/read the mobile shell's section-tabs override (the sticky strip
 * below the TopBar).
 */
export const useMobileTabsOverride = () => {
  const context = useContext(TabsOverrideContext);
  if (!context && process.env.NODE_ENV === "development") {
    console.warn(
      "useMobileTabsOverride: called outside MobileSectionTabsProvider, using noop fallback. " +
        "This is expected for pages on the legacy app shell path.",
    );
  }
  return context ?? FALLBACK_CONTEXT;
};
